module.exports = __webpack_public_path__ + "img/phone.9541bd53.svg";